import { Tour } from "nextstepjs";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
const deviceType=getDeviceType();

const offersGuide: Tour[] = [
  {
    tour: "offersTour",
    steps: [
      {
        icon: "",
        title: "",
        content:
          "Switch between tabs to explore the different types of offers. In-Store Offers will display offers that do not need to be loaded. Loaded Offers will display your digital offers that are specifically targeted and loaded to your Scene+ card to use. Past Digital Offers will display the digital offers you have already redeemed and expired digital offers.",
        selector: "#explore_offers",
        side: deviceType === "mobile" ? "top" : "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default offersGuide;
